/**
 * Done. CPD — Public Footer (Stitch v2)
 * Deep teal band with brand mark + statutory links.
 */

export function PublicFooter(): React.ReactElement {
  return (
    <footer className="w-full py-16 bg-[var(--stitch-primary)] text-[var(--stitch-on-primary)]">
      <div
        className="mx-auto px-4 md:px-10 flex flex-col md:flex-row justify-between items-center gap-10"
        style={{ maxWidth: 'var(--stitch-container-max)' }}
      >
        <div className="flex flex-col items-center md:items-start gap-3">
          <div className="flex items-center gap-2">
            <span className="material-symbols-outlined text-[var(--stitch-primary-fixed)] text-3xl">clinical_notes</span>
            <span className="stitch-font-display text-[22px] font-bold tracking-tight uppercase">Done. CPD</span>
          </div>
          <p className="stitch-font-label text-[11px] opacity-60 uppercase tracking-widest">
            © 2026 Done. CPD. All rights reserved.
          </p>
        </div>
        <nav aria-label="Footer" className="flex flex-wrap justify-center gap-x-8 gap-y-3">
          {[
            ['Privacy Policy', '/privacy'],
            ['Terms of Service', '/terms'],
            ['FAQ', '/faq'],
            ['Contact Support', 'mailto:support@chirocpd.org'],
          ].map(([label, href]) => (
            <a
              key={label}
              href={href}
              className="stitch-font-label text-[12px] uppercase opacity-70 hover:opacity-100 hover:underline underline-offset-4 transition-opacity"
            >
              {label}
            </a>
          ))}
        </nav>
      </div>
    </footer>
  );
}
